import React from 'react';

const TermsConditions = () => {
    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-white">Terms & Conditions</h1>
                    <p className="text-indigo-100 mt-2">Last updated: {new Date().getFullYear()}</p>
                </div>
                
                <div className="p-6 md:p-8 space-y-6">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">1. Acceptance of Terms</h2>
                        <p className="text-gray-600 leading-relaxed">
                            By accessing or using Abha Publication's website and services, you agree to be bound 
                            by these Terms & Conditions. If you do not agree to these terms, please do not use our services.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">2. Account Registration</h2>
                        <p className="text-gray-600 leading-relaxed">
                            You must provide accurate and complete information when creating an account. You are 
                            responsible for maintaining the confidentiality of your account credentials and for 
                            all activities that occur under your account.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">3. Purchases and Payments</h2>
                        <p className="text-gray-600 leading-relaxed">
                            All purchases of study materials, subscriptions, and other products are final. 
                            Payment processing is handled securely through Razorpay. You agree to pay all charges 
                            incurred through your account.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">4. Intellectual Property</h2>
                        <p className="text-gray-600 leading-relaxed">
                            All content on this website, including study materials, MCQs, mock tests, and other 
                            educational resources, is the property of Abha Publication and is protected by copyright laws.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">5. Prohibited Conduct</h2>
                        <p className="text-gray-600 leading-relaxed">
                            You may not share, distribute, or resell any content from our platform. You may not 
                            attempt to bypass our security measures or interfere with the proper functioning of our services.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">6. Termination</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We reserve the right to suspend or terminate your account at our sole discretion, 
                            without notice, for conduct that violates these terms or is harmful to other users or our platform.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">7. Limitation of Liability</h2>
                        <p className="text-gray-600 leading-relaxed">
                            To the fullest extent permitted by law, Abha Publication shall not be liable for any 
                            indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">8. Contact Information</h2>
                        <p className="text-gray-600 leading-relaxed">
                            For any questions regarding these Terms & Conditions, please contact us at:
                            <span className="block mt-2 text-indigo-600">abhapublicationindia@gmail.com</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;